import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import Model from '@models/model';
import ProposalLocation from '@models/proposal-location';

export const PROPOSAL_STATUS_SIGNED = 'Signed';
export const PROPOSAL_STATUS_IN_PROGRESS = 'In Progress';
export const PROPOSAL_STATUS_CHANGES_NEEDED = 'Changes Needed';

export const RECAP_TYPE_EQUIPMENT = 'Equipment';
export const RECAP_TYPE_EXCHANGE = 'Exchange';
export const RECAP_TYPE_OTHER = 'Other';
export const RECAP_TYPE_SANITATION = 'Sanitation';

export const RECAP_TYPES = [
    { id: RECAP_TYPE_EQUIPMENT, text: RECAP_TYPE_EQUIPMENT },
    { id: RECAP_TYPE_EXCHANGE, text: RECAP_TYPE_EXCHANGE },
    { id: RECAP_TYPE_OTHER, text: RECAP_TYPE_OTHER },
    { id: RECAP_TYPE_SANITATION, text: RECAP_TYPE_SANITATION },
];

export default class Proposal extends Model {
    static className = 'Proposal';

    static allowsEdit = true;

    static allowedFieldEdits = [
        'override_proposal_pdf_file_id',
    ];

    resource() {
        return 'proposals';
    }

    get formFieldCasts() {
        return {
            monthly_price_override: CurrencyFormatter.formFormat,
        };
    }

    relations() {
        return {
            locations: ProposalLocation,
        };
    }

    proposalLocations() {
        return this.hasMany(ProposalLocation);
    }

    get billingAddressFormatted() {
        if (!this.billing_address_line_1) return '';
        return `${this.billing_address_line_1}<br>
                ${this.billing_address_line_2 ? `${this.billing_address_line_2}<br>` : ''}
                ${this.billing_city}, ${this.billing_state} ${this.billing_zip}`;
    }
}
